module.exports = __webpack_public_path__ + "img/green_017.37d185ab.png";